(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["me-editorial-home"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var verses = [
      { text: "Be ye transformed by the renewing of your mind.", reference: "Romans 12:2 (KJV)" },
      { text: "Wisdom is the principal thing; therefore get wisdom: and with all thy getting get understanding.", reference: "Proverbs 4:7 (KJV)" },
      { text: "Prove all things; hold fast that which is good.", reference: "1 Thessalonians 5:21 (KJV)" },
      { text: "So teach us to number our days, that we may apply our hearts unto wisdom.", reference: "Psalm 90:12 (KJV)" },
      { text: "For which of you, intending to build a tower, sitteth not down first, and counteth the cost?", reference: "Luke 14:28 (KJV)" },
      { text: "If any of you lack wisdom, let him ask of God, that giveth to all men liberally, and upbraideth not; and it shall be given him.", reference: "James 1:5 (KJV)" },
      { text: "He that answereth a matter before he heareth it, it is folly and shame unto him.", reference: "Proverbs 18:13 (KJV)" },
      { text: "Forgetting those things which are behind, and reaching forth unto those things which are before.", reference: "Philippians 3:13 (KJV)" },
      { text: "Let us not be weary in well doing: for in due season we shall reap, if we faint not.", reference: "Galatians 6:9 (KJV)" },
      { text: "They that wait upon the LORD shall renew their strength; they shall mount up with wings as eagles.", reference: "Isaiah 40:31 (KJV)" },
      { text: "Commit thy works unto the LORD, and thy thoughts shall be established.", reference: "Proverbs 16:3 (KJV)" },
      { text: "What doth the LORD require of thee, but to do justly, and to love mercy, and to walk humbly with thy God?", reference: "Micah 6:8 (KJV)" },
      { text: "Be strong and of a good courage; be not afraid, neither be thou dismayed.", reference: "Joshua 1:9 (KJV)" },
      { text: "Trust in the LORD with all thine heart; and lean not unto thine own understanding.", reference: "Proverbs 3:5 (KJV)" }
    ];
    var formatter = new Intl.DateTimeFormat("en-US", {
      timeZone: "America/Chicago",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hourCycle: "h23"
    });
    var elements = document.querySelectorAll("[data-daily-scripture]");
    var timer;

    if (!elements.length) return;

    function centralParts(date) {
      var result = {};
      formatter.formatToParts(date).forEach(function (part) {
        if (part.type !== "literal") result[part.type] = part.value;
      });
      return result;
    }

    function updateVerse() {
      var parts = centralParts(new Date());
      var today = Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day));
      var anchor = Date.UTC(2026, 8, 28);
      var dayNumber = Math.floor((today - anchor) / 86400000);
      var index = ((dayNumber % verses.length) + verses.length) % verses.length;
      var verse = verses[index];

      elements.forEach(function (element) {
        var text = element.querySelector("[data-verse-text]");
        var reference = element.querySelector("[data-verse-reference]");
        if (text) text.textContent = verse.text;
        if (reference) reference.textContent = verse.reference;
      });
    }

    function delayToNextMidnight() {
      var parts = centralParts(new Date());
      var target = Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day) + 1);
      var candidate = target;

      for (var attempt = 0; attempt < 3; attempt += 1) {
        var local = centralParts(new Date(candidate));
        var represented = Date.UTC(Number(local.year), Number(local.month) - 1, Number(local.day), Number(local.hour), Number(local.minute), Number(local.second));
        candidate += target - represented;
      }

      return Math.max(1000, candidate - Date.now());
    }

    function scheduleNextUpdate() {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        updateVerse();
        scheduleNextUpdate();
      }, delayToNextMidnight());
    }

    updateVerse();
    scheduleNextUpdate();
    document.addEventListener("visibilitychange", function () {
      if (!document.hidden) {
        updateVerse();
        scheduleNextUpdate();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
